// Z-Wave-Geräteliste (Inventar-Index, Suche).
//
// Datenfluss: kein eigener Abruf mehr -- die Liste kommt aus dem gemeinsamen
// Steckdosen-Stand (lib/steckdosen.svelte.ts), den das Homelab-Protokoll
// (Topic steckdose.stand, docs/protokoll.md › „Steckdosen über das Protokoll“)
// speist; derselbe Stand liefert die Energie-Geräte. REST nur beim Start, als
// Revalidator, nach Aktionen und als Neuversuch -- dort. Bis 02.11.2026 holte
// dieser Store alle 30 s (und bei jedem WS-Signal "zwave") GET
// /v2-api/zwave/devices.

import { getZwaveGeraete, refreshSteckdosen, startSteckdosen } from "./steckdosen.svelte";
import type { ZwaveDevice } from "./types";

let _aus: (() => void) | undefined;

export function startZwaveSummary(): void {
  if (_aus) return;
  _aus = startSteckdosen();
}

export function stopZwaveSummary(): void {
  _aus?.();
  _aus = undefined;
}

export function getZwaveSummary(): ZwaveDevice[] | undefined {
  return getZwaveGeraete();
}

export async function refreshZwaveSummary(): Promise<void> {
  await refreshSteckdosen();
}
